import { render, staticRenderFns } from "./CreateCampaignReward.vue?vue&type=template&id=f9835f0a&scoped=true"
import script from "./CreateCampaignReward.vue?vue&type=script&lang=js"
export * from "./CreateCampaignReward.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignReward.vue?vue&type=style&index=0&id=f9835f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9835f0a",
  null
  
)

export default component.exports